import React from 'react';
import { Timer, CheckCircle, Award, PoundSterling, Phone, Map } from 'lucide-react';
import { whyChooseUs, images } from '../data/mock';

const iconMap = {
  timer: Timer,
  checkCircle: CheckCircle,
  award: Award,
  poundSterling: PoundSterling,
  phone: Phone,
  map: Map
};

const WhyChooseUs = () => {
  return (
    <section id="about" className="py-24 bg-slate-900">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Side - Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src={images.recovery}
                alt="Professional Vehicle Recovery Service"
                className="w-full h-[600px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 to-transparent"></div>
            </div>
            
            {/* Decorative element */}
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-blue-600/20 rounded-full blur-3xl"></div>
          </div>

          {/* Right Side - Content */}
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Why Choose 
              <span className="block text-blue-500">ADP Motors & Recovery?</span>
            </h2>
            
            <p className="text-xl text-gray-400 mb-12 leading-relaxed">
              We've built our reputation on reliability, professionalism, and dedication 
              to our customers. Here's what sets us apart:
            </p>

            {/* Features List */}
            <div className="space-y-6">
              {whyChooseUs.map((feature) => {
                const IconComponent = iconMap[feature.icon];
                return (
                  <div 
                    key={feature.id}
                    className="flex items-start space-x-4 group"
                  >
                    <div className="flex-shrink-0 w-12 h-12 bg-blue-600/20 rounded-lg flex items-center justify-center group-hover:bg-blue-600/30 transition-colors duration-200">
                      <IconComponent className="w-6 h-6 text-blue-500" />
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-white mb-2 group-hover:text-blue-400 transition-colors duration-200">
                        {feature.title}
                      </h3>
                      <p className="text-gray-400">
                        {feature.description}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
